import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useCustomer } from "@/context/CustomerContext";

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setCustomer } = useCustomer();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api.post("/customer/auth/session", {}, { headers: { "X-Session-ID": sid } })
      .then((r) => setCustomer(r.data))
      .catch(() => setCustomer(false))
      .finally(() => navigate("/app", { replace: true }));
  }, [location.hash, navigate, setCustomer]);

  return <div data-testid="auth-callback" className="min-h-screen bg-[#050807]" />;
};
